import urlFilter from "../filters/url.filter"

/**  Данные манифеста API. */
export class ApiData {
  /**
   * API состояние.
   * 0 - Сервер недоступен, 1 - работает.
   */
  public State = -1;

  /**Версия веб клиента */
  public Version = ""

  /**
   * Файл настроек продуктов.
   */
  public ProductsFile: string = "";

  /**
   * Файл настроек продуктов.
   */
  public QuickOperationsFile: string = "";

  /**
   * Код операции для блокировки-разблкировки карты.
   * Используется в BlockUnblockCardPrepareOperationSendAsync, BlockUnblockCardExecuteOperationSendAsync.
   */
  public OperationCodeOfBlockUnblockCard: string = "";

  /**
   * Код операции для настройки уведомлений пользователя и СНИЛС.
   * Используется в NotificationUserPrepareOperationSendAsync, NotificationUserExecuteOperationSendAsync.
   * Используется в SnilsPrepareOperationSendAsync, SnilsExecuteOperationSendAsync.
   */
  public OperationCodeOfChangeContactInfo: string = "";

  /**
   * Код операции для восстановления пароля от учётной записи.
   */
  public OperationCodeOfRecoveryPassword: string = "";

  /**
   * Код операции для восстановления логина от учётной записи.
   */
  public OperationCodeOfRecoveryLogin: string = "";

  /**
   * Код операции для регистрации персоны.
   */
  public OperationCodeOfRegistration: string = "";

  /**
   * Код операции для проверки регистрации персоны.
   */
  public OperationCodeOfCheckRegistration: string = "";

  /**
   * Код операции для выбора категории повышенного кэшбэка.
   */
  public OperationCodeOfSelectCategoryIncreasedCashBack: string = "";

  /**
   * Код операции перевода между счетами.
   */
  public OperationCodeOfToContract: string = "";

  /**
   * Код операции для установки лимитов карты.
   */
  public OperationCodeOfSetCardLimits: string = "";

  /**
   * Код операции для перевода кешбэка.
   */
  public OperationCodeOfTransferCashBack: string = "";

  public OperationCodeOfOpenCard: string = "";

  /**
   * Код операции для установки банка по умолчанию в СБП.
   */
  public OperationCodeOfSetSbpDefaultBank: string = "";

  /**
   * Код операции для установки разрешений использования СБП.
   */
  public OperationCodeOfSetSbpEnable: string = "";

  /**
   * Код операции для установки счета для входящих переводов СБП.
   */
  public OperationCodeOfSetSbpContract: string = "";

  /**
   *  Код операции для установки сгласия с правилами.
   */
  public OperationCodeOfSetAcceptedRules: string = "";

  /**
 * Код операции для синронизации статуса установки push.
 */
  public OperationCodeOfSyncPushState: string = "";

  /**
   * Код операции для установки видимости счета.
   */
  public OperationCodeOfSetContractVisibility: string = "";

  /**
   * Код операции для установки видимости карты.
   */
  public OperationCodeOfSetCardVisibility: string = "";

  /**
   * Код операции для досрочного погашения.
   */
  public OperationCodeOfEarlyRepayment: string = "";

  /**
   * Код операции для досрочного погашения кредита.
   */
  public OperationCodeOfAdvancedRepayment: string = "";

  /**
   * Код операции для установки счета по умолчанию для зачислений.
   */
  public OperationCodeOfSetDefaultInAccount: string = "";

  /**
   * Код операции для смены СМС пакета.
   */
  public OperationCodeOfChangeSmsPacket: string = "";

  /**
   * Код операции для смены пин кода.
   */
  public OperationCodeOfCardPinCode: string = "";

  /**
   * Код операции для смены категории кэшбэка.
   */
  public OperationSelectCategoryCashBack: string = "";

  /**
   * Код операции для открытия вклада.
   */
  public OperationCodeOfOpenDeposit: string = "";

  /**
 * Код операции для открытия текущего счета.
 */
    public OperationCodeOfOpenCurrentAccount: string = "";

  /**
   * Код операции для закрытия вклада.
   */
  public OperationCodeOfCloseDeposit: string = "";

  /**
 * Код операции для закрытия текущего счета.
 */
  public OperationCodeOfCloseCurrentAccount: string = "";

  /**
   * Код операции для заявки на кредит.
   */
  public OperationCodeOfCreditRequest: string = "";

  /**
   * Код операции для перевода СБП.
   */
  public OperationCodeOfSbpOperation: string = "";

  /**
   * Код операции перевода по номеру телефона.
   */
  public OperationCodeOfToOtherContractByPhone: string = "";

  /**
   * Код операции перевода по номеру карты.
   */
  public OperationCodeOfToOtherContractByCard: string = ""

  /**
   * Код операции перевода по свободным реквизитам.
   */
  public OperationCodeOfToExt: string = ""

  /**
   *  Код операции заполнения операции по данным начисления.
   */
  public OperationCodeOfFillOperationFromCharge: string = ""

  /**
   *  Код операции для выбора банков СБП
   */
  public OperationCodeOfSetSbpMe2MeAcceptedBanks: string = ""

  public OperationCodeOfGetSbpBanks: string = ""

  public OperationCodeOfSetDefaultOutAccount: string = ""

  public OperationCodeOfGetServerCommands: string = ""

  public OperationCodeOfSetServerCommandResponse: string = ""

  public OperationCodeOfMe2MeOperation: string = "";

  public OperationCodeOfSbpC2BOperation: string = "";

  public OperationCodeOfGetCVVCode: string = "";

  public OperationCodeOfCreateVirtualCard: string = "";

  /**
   * Время жизни кода верификации.
   */
  public VerificationCodeTimeLife: number = 0;

  /**
   * Время жизни кода верификации СБП.
   */
  public SbpVerificationCodeLifeTime: number = 180;

  /**
   * Ссылка на файл правил.
   */
  public RulesFile: string = "";

  /**
   * Ссылка на файл правил.
   */
  public TarifsFile: string = "";

  /**
   * Ссылка на файл тарифов ДКБО.
   */
  public DKBOTarifsFile: string = "";

  /**
   * Ссылка на файл ДКБО.
   */
  public DKBORulesFile: string = "";

  /**
   * Ссылка на файл обработки персональных данных.
   */
  public PersonalDataRulesFile: string = "";

  /**
   * Ссылка на файл правил безопасности.
   */
  public SecurityRulesFile: string = "";

  /**
   * Версия правил и тарифов.
   */
  public AcceptFilesVersion: string = "";

  /**
   * Исключенные операции с быстрого каталога.
   * Из тех что находятся в корне каталога.
   */
  public ExcludedFromFastCatalogOperationIds: string = "";

  public OperationCodeOfSetChargeVisibility: string = "";

  /**
  * Время жизни сессии клиента (в минутах)
  */
  public SessionTimeLife: number = 15;

  /**
  * Флаг отображения функционала ЕБС ЕСИА
  */
  public EbsEsiaEnable: boolean = false;

  /**
  * Флаг отображения функционала начислений
  */
  public ChargesEnable: boolean = false;

  /**
  * Файл Тарифы банка
  */
  public EbsTarifs: string = '';

  /**
  * Файл Условия выпуска и использования банковских расчетных карт
  */
  public CardConditions: string = '';

  public InquiriesFile: string = '';

  /**
  * Файл витрины банка
  */
  public ShowcaseFile: string = '';
  	 /**
		* Код операции со штрихкодом 
    */
		public  OperationCodeOfBarcode: string = '';

    /**
     * Код операции для привязки счета C2B.
     */
    public  OperationCodeOfSetSbpC2BBinding: string = '';

   /**
    * Код операции для получения привязок счетов C2B.
    */
		public OperationCodeOfGetSbpC2BBindings: string = '';

    public ChatEnable: boolean = false;

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.State = src.State ?? -1;
      this.Version = src.Versions?.VueClient ?? "";
      this.ProductsFile = src.ProductsFile ?? "";
      this.QuickOperationsFile = src.QuickOperationsFile ?? "";

      this.EbsTarifs = urlFilter(src.EbsTarifs ?? "");
      this.ShowcaseFile = urlFilter(src.ShowcaseFile ?? "");
      this.CardConditions = urlFilter(src.CardConditions ?? "");
      this.InquiriesFile = urlFilter(src.InquiriesFile ?? "");

      this.OperationCodeOfBlockUnblockCard =
        src.OperationCodes?.BlockUnblockCard ?? "";
      this.OperationCodeOfChangeContactInfo =
        src.OperationCodes?.ChangeContactInfo ?? "";
      this.OperationCodeOfRecoveryPassword =
        src.OperationCodes?.RecoveryPassword ?? "";
      this.OperationCodeOfRecoveryLogin =
        src.OperationCodes?.RecoveryLogin ?? "";
      this.OperationCodeOfRegistration = src.OperationCodes?.Registration ?? "";
      this.OperationCodeOfCheckRegistration =
        src.OperationCodes?.CheckPersonRegistration ?? "";
      this.OperationCodeOfSelectCategoryIncreasedCashBack =
        src.OperationCodes?.OperationCodeOfSelectCategoryIncreasedCashBack ??
        "";
      this.OperationCodeOfToContract = src.OperationCodes?.ToContract ?? "";
      this.OperationCodeOfSetCardLimits =
        src.OperationCodes?.SetCardLimits ?? "";
      this.OperationCodeOfTransferCashBack =
        src.OperationCodes?.TransferCashBack ?? "";
      this.OperationCodeOfSetSbpDefaultBank =
        src.OperationCodes?.SetSbpDefaultBank ?? "";
      this.OperationCodeOfSetSbpEnable = src.OperationCodes?.SetSbpEnable ?? "";
      this.OperationCodeOfSetSbpContract =
        src.OperationCodes?.SetSbpContract ?? "";
      this.OperationCodeOfSetAcceptedRules =
        src.OperationCodes?.SetAcceptedRules ?? "";
      this.OperationCodeOfSyncPushState =
        src.OperationCodes?.SyncPushState ?? "";
      this.OperationCodeOfSetContractVisibility =
        src.OperationCodes?.SetContractVisibility ?? "";
      this.OperationCodeOfSetCardVisibility =
        src.OperationCodes?.SetCardVisibility ?? "";
      this.OperationCodeOfEarlyRepayment =
        src.OperationCodes?.EarlyRepayment ?? "";
      this.OperationCodeOfAdvancedRepayment =
        src.OperationCodes?.AdvancedRepayment ?? "";
      this.OperationCodeOfSetDefaultInAccount =
        src.OperationCodes?.SetDefaultInAccount ?? "";
      this.OperationCodeOfChangeSmsPacket =
        src.OperationCodes?.ChangeSmsPacket ?? "";
      this.OperationCodeOfCardPinCode = src.OperationCodes?.ChangeCardPin ?? "";
      this.OperationSelectCategoryCashBack = src.OperationCodes?.SelectCategoryCashBack ?? "";
      this.OperationCodeOfOpenDeposit = src.OperationCodes?.OpenDeposit ?? "";
      this.OperationCodeOfOpenCurrentAccount = src.OperationCodes?.OpenCurrentAccount ?? "";
      this.OperationCodeOfCreditRequest =
        src.OperationCodes?.CreditRequest ?? "";
      this.OperationCodeOfCloseDeposit = src.OperationCodes?.CloseDeposit ?? "";
      this.OperationCodeOfCloseCurrentAccount = src.OperationCodes?.CloseCurrentAccount ?? "";
      this.OperationCodeOfSbpOperation =
        src.OperationCodes?.SbpOperation ?? "";
      this.OperationCodeOfToOtherContractByPhone =
        src.OperationCodes?.ToOtherContractByPhone ?? "";
      this.OperationCodeOfToOtherContractByCard =
        src.OperationCodes?.ToOtherContractByCard ?? "";
      this.OperationCodeOfToExt =
        src.OperationCodes?.ToExt ?? "";
      this.OperationCodeOfFillOperationFromCharge =
        src.OperationCodes?.FillOperationFromCharge ?? "";
        this.OperationCodeOfBarcode =
        src.OperationCodes?.BarcodeOperation ?? "";
      this.OperationCodeOfGetSbpC2BBindings =
        src.OperationCodes?.GetSbpC2BBindings ?? "";
      this.OperationCodeOfSetSbpC2BBinding =
        src.OperationCodes?.SetSbpC2BBinding ?? "";

      this.OperationCodeOfSetChargeVisibility = src.OperationCodes?.SetChargeVisibility ?? "";

      this.OperationCodeOfOpenCard = src.OperationCodes.OpenCard ?? "";

      this.OperationCodeOfMe2MeOperation = src.OperationCodes?.Me2Me ?? "";

      this.OperationCodeOfSbpC2BOperation = src.OperationCodes?.SbpC2BOperation ?? "";

      this.OperationCodeOfGetCVVCode = src.OperationCodes?.OperationCodeOfGetCVVCode ?? "";

      this.OperationCodeOfCreateVirtualCard = src.OperationCodes?.CreateVirtualCard ?? "";

      this.OperationCodeOfGetServerCommands = src.OperationCodes?.GetServerCommands ?? "";
      this.OperationCodeOfSetServerCommandResponse = src.OperationCodes.SetServerCommandResponse ?? "";

      this.OperationCodeOfSetSbpMe2MeAcceptedBanks = src.OperationCodes?.SetAcceptedPullBanks ?? "";
      this.OperationCodeOfGetSbpBanks = src.OperationCodes?.GetSbpBanks ?? "";
      this.OperationCodeOfSetDefaultOutAccount = src.OperationCodes?.SetDefaultOutAccount ?? "";

      this.EbsEsiaEnable = src.EbsEsiaEnable && src.EbsEsiaEnable === '1' ? true : false;
      this.ChargesEnable = src.ChargesEnable && src.ChargesEnable === '1' ? true : false;
      this.SbpVerificationCodeLifeTime = src.SbpVerificationCodeLifeTime ?? 0;
      this.VerificationCodeTimeLife = src.VerificationCodeTimeLife ?? 0;
      this.RulesFile = urlFilter(src.RulesFile ?? "");
      this.TarifsFile = urlFilter(src.TarifsFile ?? "");
      this.DKBOTarifsFile = urlFilter(src.DKBOTarifsFile ?? "");
      this.DKBORulesFile = urlFilter(src.DKBORulesFile ?? "");
      this.PersonalDataRulesFile = urlFilter(src.PersonalDataRulesFile ?? "");
      this.SecurityRulesFile = urlFilter(src.SecurityRulesFile ?? "");

      this.AcceptFilesVersion = src.AcceptFilesVersion ?? "";
      this.ExcludedFromFastCatalogOperationIds =
        src.ExcludedFromFastCatalogOperationIds ?? "";

      this.SessionTimeLife = src.ServiceSettings?.SessionTimeLife ?? 15;
      this.ChatEnable = !!src.ChatEnable;
    }
  }

  public Override(data: ApiData): void {
    for(const k in data) {
      if(data[k])
        this[k] = data[k];
    }
  }
}
